import { useMemo } from 'react';
import { getDateFormatTemplateString } from 'utils/core/date';

import { useSPIntl } from './useIntl';

export function useLocalDateFormat() {
  const { locale } = useSPIntl();
  const dateFormat = useMemo(() => getDateFormatTemplateString(locale), [locale]);
  return [dateFormat, locale];
}
